import s from './About.module.scss';
import logo from '../../assets/images/test.png';
import SubHeader from '../../components/SubHeader/SubHeader';
import { Aside } from '../../components/Aside/Aside';
import { Helmet } from "react-helmet";
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import titleImage from "../../assets/images/titleImage.png";
import React from "react";



const About = () => {
    const breadcrumbItems = [
        { name: 'ホーム ', link: '/' },
        { name: 'ケアンズツアー・観光がジェイさんツアーだとスゴい4つの理由'}
    ];
  return (
    <>
          <Helmet>
        <title>ケアンズツアー・観光がジェイさんツアーだとスゴい4つの理由</title>
        <meta property="og:title" content="ケアンズツアー・観光がジェイさんツアーだとスゴい4つの理由" />
        <meta property="og:image" content={`${process.env.REACT_APP_URL}/og-image.png`} />
        <meta property="og:url" content={`${process.env.REACT_APP_URL}/great`} />
        <meta name="description" content="自社ツアーやオプショナルツアーも予約できます！" />
        <meta property="og:description" content="自社ツアーやオプショナルツアーも予約できます！" />
        <meta property="og:type" content="article" />

      </Helmet>

        <div className={"row mt-3"}>
            <div className={"col-12"}>
                <Breadcrumb items={breadcrumbItems}/>
                <div className={s.titleContainer}>
                    <h2><img className={s.titleImage} src={titleImage}/>ケアンズツアー・観光がジェイさんツアーだとスゴい4つの理由</h2>
                </div>
            </div>
        </div>
        <div className="row mt-5 justify-content-center">
            <div className="col-12 col-lg-10">
                <section className={s.contentWrapper}>
                    <div className={s.imageContainer}>
                        <img
                            fetchPriority="high"
                            decoding="async"
                            width="750"
                            height="259"
                            src="https://dev.mightyaussie.com/wp-content/uploads/2019/04/deal_tit1.png"
                            alt="他とはちがう！ジェイさんツアーのスゴイところ４つ"
                            className={s.image}
                        />
                    </div>
                    <div className={s.imageContainer}>
                        <img
                            decoding="async"
                            width="750"
                            height="237"
                            src="https://dev.mightyaussie.com/wp-content/uploads/2019/04/deal_tit2.png"
                            alt="すごい理由1.ジェイさんツアーはどこよりも低価格だからスゴイ"
                            className={s.image}
                        />
                    </div>

                    <div className={s.imageContainer}>
                        <img
                            decoding="async"
                            width="648"
                            height="116"
                            src="https://dev.mightyaussie.com/wp-content/uploads/2019/04/deal_tit3.png"
                            alt="理由1.安くてスゴイ！最安値保証"
                            className={s.image}
                        />
                    </div>

                    <div className={s.textContainer}>
                        <p>
                <span style={{ color: '#993300', fontSize: '20pt' }}>
                  <strong>
                    中間マージンがないからどこよりも安い！<br />
                    他社より1円でも高い場合はご相談ください！
                  </strong>
                </span>
                        </p>
                    </div>

                    <div className={s.infoBox}>
                        <i className="fas fa-info-circle" />
                        <p>
                            <strong className={s.under}>
                                ケアンズオプショナルツアーが他社より1円でも高い場合はご相談ください！
                            </strong>
                            <br />
                            ジェイさんツアーは代理店に手数料を支払う必要がありません。そのため、同業他社と比べ中間マージンを抑えることができております。<br />
                            そのため、<strong className={s.under}>他社と同じツアーでも最安値かつ安心サポートを提供することができます！</strong>
                        </p>
                    </div>

                    <div className={s.wrapper}>
                        <div className={s.imageContainer}>
                            <img
                                decoding="async"
                                width="750"
                                height="303"
                                src="https://dev.mightyaussie.com/wp-content/uploads/2019/04/deal_tit5.png"
                                alt="すごい理由2.ジェイさんツアーはどこよりもアットホームで安心感がスゴイ！"
                                className={s.image}
                            />
                        </div>
                        <div className={s.imageContainer}>
                            <img
                                decoding="async"
                                width="647"
                                height="105"
                                src="https://dev.mightyaussie.com/wp-content/uploads/2019/04/deal_tit6.png"
                                alt="理由1.安心感がスゴイ！予約前でも LINE相談ができます"
                                className={s.image}
                            />
                        </div>
                        <div className={s.textContainer}>
                            <table className={s.table}>
                                <tbody>
                                <tr>
                                    <td>
                                        <img
                                            loading="lazy"
                                            decoding="async"
                                            className={s.icon}
                                            src="https://dev.mightyaussie.com/wp-content/uploads/2019/04/deal_ico2.png"
                                            alt=""
                                            width="80"
                                            height="80"
                                        />
                                    </td>
                                    <td>
                      <span className={s.textHighlight}>
                        <strong>
                          服装・天気・食事など気になることは<br />
                          何でも気軽に質問・相談ください！
                        </strong>
                      </span>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>

                        <div className={s.infoBox}>
                            <i className="fas fa-info-circle" />
                            <p>
                                ジェイさんツアーでは、LINEでお客様のお困り事や質問にお答えしております。<br />
                                どんなご相談にもお答えしますので、お気軽にご相談くださいね！
                            </p>
                        </div>

                        <div className={s.imageContainer}>
                            <img
                                decoding="async"
                                width="690"
                                height="410"
                                src="https://dev.mightyaussie.com/wp-content/uploads/2019/04/deal_photo.png"
                                alt="LINEでのやり取り事例"
                                className={s.image}
                            />
                        </div>

                        <div className={s.buttonContainer}>
                            <a
                                className={s.button}
                                href="https://line.me/R/ti/p/%40dii1064j"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <i className="fa fa-arrow-circle-right" /> LINEで聞いてみる
                            </a>
                        </div>

                        <div className={s.imageContainer}>
                            <img
                                decoding="async"
                                width="637"
                                height="105"
                                src="https://dev.mightyaussie.com/wp-content/uploads/2019/04/deal_tit7.png"
                                alt="理由2.安心感がスゴイ！英語が話せなくてもOK"
                                className={s.image}
                            />
                        </div>

                        <div className={s.textContainer}>
                            <table className={s.table}>
                                <tbody>
                                <tr>
                                    <td>
                                        <img
                                            loading="lazy"
                                            decoding="async"
                                            className={s.icon}
                                            src="https://dev.mightyaussie.com/wp-content/uploads/2019/04/deal_ico3.png"
                                            alt=""
                                            width="80"
                                            height="80"
                                        />
                                    </td>
                                    <td>
                      <span className={s.textHighlight}>
                        <strong>
                          現地在住10年以上の<br />
                          ベテラン日本人ガイドがご案内！
                        </strong>
                      </span>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>

                        <div className={s.infoBox}>
                            <i className="fas fa-info-circle" />
                            <p>
                                ジェイさんツアーでは、ケアンズ在住の日本人や、日本語ペラペラのジェイさんなど、10年以上の実績があるベテランガイドがご案内！だから英語がしゃべれなくても安心！<br />
                                <span className={s.fatte}>※ジェイさんオリジナルツアーが日本語ガイド対象です</span><br />
                                <span className={s.fatte}>※日本語ガイド対象は商品画像に日本のマークがついているものが対象です</span>
                            </p>
                        </div>

                        <div className={s.imageContainer}>
                            <img
                                decoding="async"
                                width="671"
                                height="110"
                                src="https://dev.mightyaussie.com/wp-content/uploads/2019/04/deal_tit8.png"
                                alt="理由3.安心感がスゴイ！1300人以上の喜びの声"
                                className={s.image}
                            />
                        </div>

                        <div className={s.textContainer}>
              <span className={s.textHighlight}>
                <strong>
                  ジェイさんツアーは、
                  たくさんのお客様に
                  満足いただいております！
                  Googleの口コミも
                  どんどん増加中！
                </strong>
              </span>
                        </div>

                        <div className={s.buttonContainer}>
                            <a
                                className={s.button}
                                href="https://goo.gl/maps/QCfNnfCCe8s"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <i className="fa fa-arrow-circle-right" /> Googleの口コミを見る
                            </a>
                        </div>

                        <div className={s.chartContainer}>
                            <h2 className={s.chartTitle}>
                                満足度調査（弊社アンケートによる）
                            </h2>
                            <div className={s.chartCanvas}>
                                <img src={logo} alt="" />
                            </div>
                            <p style={{ textAlign: 'right' }}>
                                有効アンケート数:1488（2019/10/3現在）<br />
                                <span className={s.fatte}>※現在はアンケートは終了しております</span>
                            </p>
                        </div>

                        <div className={s.infoBox}>
                            <i className="fas fa-info-circle" />
                            <p>
                                ジェイさんツアーに集まった喜びの声は約1,500人！<br />
                                手間のかかるアンケートにもかかわらず、わざわざお答えいただきありがとうございました！<br />
                                ツアーの雰囲気や食事、ジェイさんツアースタッフの印象など様々なお客様の声があり、どのツアーにしようか迷われてましたらぜひ、お客様の声ページや<a href="https://goo.gl/maps/QCfNnfCCe8s" target="_blank" rel="noopener noreferrer">Googleマップの口コミ</a>を参考くださいませ！
                            </p>
                            <p>
                                現在はアンケートは終了し、Webサイト上でもコメントを残したりGoogleのクチコミでかんたんに感想をいただけるようになっておりますので、ぜひご活用くださいませ！
                            </p>
                        </div>
                    </div>
                    <div className={s.imageContainer}>
                        <figure className={s.figure}>
                            <div className={`${s.imageWrapper} ${s.boxBorderGrey}`}>
                                <img
                                    loading="lazy"
                                    decoding="async"
                                    width="750"
                                    height="238"
                                    src="https://dev.mightyaussie.com/wp-content/uploads/2019/04/deal_tit9.png"
                                    className={s.image}
                                    alt="すごい理由3.ジェイさんツアーは現地の会社だから対応力がスゴイ！"
                                    title="deal_tit9"
                                />
                            </div>
                        </figure>
                    </div>

                    <div className={s.imageContainer}>
                        <figure className={s.figure}>
                            <div className={`${s.imageWrapper} ${s.boxBorderGrey}`}>
                                <img
                                    loading="lazy"
                                    decoding="async"
                                    width="680"
                                    height="140"
                                    src="https://dev.mightyaussie.com/wp-content/uploads/2019/04/deal_tit10.png"
                                    className={s.image}
                                    alt="理由1.対応力がスゴイ　現地でいつでもサポートOK"
                                    title="deal_tit10"
                                />
                            </div>
                        </figure>
                    </div>

                    <div className={s.textColumn}>
                        <div className={s.wrapper}>
                            <table className={s.tableNone}>
                                <tbody>
                                <tr>
                                    <td style={{ width: '80px' }}>
                                        <img
                                            loading="lazy"
                                            decoding="async"
                                            className={s.icon}
                                            src="https://dev.mightyaussie.com/wp-content/uploads/2019/04/deal_ico4.png"
                                            alt=""
                                            width="80"
                                            height="80"
                                        />
                                    </td>
                                    <td>
                        <span style={{ color: '#993300', fontSize: '20pt' }}>
                            <strong>
                                オーストラリア現地に会社があるから、<br />
                                万が一の際は24時間サポートできます！
                            </strong>
                        </span>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className={s.infoBox}>
                        <div className={s.icon}>
                            <i className="fas fa-info-circle" />
                        </div>
                        <p>
                            ジェイさんのツアーは政府公認会社でオーストラリアに登録された
                            <strong className={s.under}>創業20年以上</strong>のJAY&amp;JAY Pty.Ltd.社が運営しています。<br />
                            だからこそ、もしもの時も安心対応です。<br />
                            <span className={s.note}>
            ※常に24時間サポートを保証ではなく、万が一の緊急対応のケースを指します
        </span>
                        </p>
                    </div>

                    <div className={s.imageContainer}>
                        <figure className={s.figure}>
                            <div className={`${s.imageWrapper} ${s.boxBorderGrey}`}>
                                <img
                                    loading="lazy"
                                    decoding="async"
                                    width="692"
                                    height="164"
                                    src="https://dev.mightyaussie.com/wp-content/uploads/2019/04/deal_tit11.png"
                                    className={s.image}
                                    alt="理由2.対応力がスゴイ！現地でのお支払いOK"
                                    title="deal_tit11"
                                />
                            </div>
                        </figure>
                    </div>

                    <div className={s.textColumn}>
                        <div className={s.wrapper}>
                            <table className={s.tableNone}>
                                <tbody>
                                <tr>
                                    <td style={{ width: '80px' }}>
                                        <img
                                            loading="lazy"
                                            decoding="async"
                                            className={s.icon}
                                            src="https://dev.mightyaussie.com/wp-content/uploads/2019/04/deal_ico5.png"
                                            alt=""
                                            width="80"
                                            height="80"
                                        />
                                    </td>
                                    <td>
                        <span style={{ color: '#993300', fontSize: '20pt' }}>
                            <strong>
                                現地で現金やクレジットカード決済ができます！<br />
                                海外での決済も現地決済なら安心です。
                            </strong>
                        </span>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className={s.infoBox}>
                        <div className={s.icon}>
                            <i className="fas fa-info-circle" />
                        </div>
                        <p>
                            ジェイさんツアー催行のツアーでは、ツアー当日に全額清算も可能です。<br />
                            現地でのお支払いはオーストラリアドル、日本円、下記のクレジットカードがご利用いただけますが、
                            クレジットカード決済は以下の手数料がかかりますのでご注意ください。
                        </p>
                        <p>
                            <strong>■当日、現地決済の場合</strong><br />
                            VISA,JCB,MASTER,AMEXカード：<span style={{ color: '#e00b0b' }}><strong>手数料2.5%</strong></span><br />
                            <img
                                loading="lazy"
                                decoding="async"
                                className={s.cardIcon}
                                src="https://dev.mightyaussie.com/wp-content/uploads/2019/04/card-visa.png"
                                alt=""
                                width="43"
                                height="33"
                            />
                            <img
                                loading="lazy"
                                decoding="async"
                                className={s.cardIcon}
                                src="https://dev.mightyaussie.com/wp-content/uploads/2019/04/card-jcb.png"
                                alt=""
                                width="43"
                                height="33"
                            />
                            <img
                                loading="lazy"
                                decoding="async"
                                className={s.cardIcon}
                                src="https://dev.mightyaussie.com/wp-content/uploads/2019/04/card-master.png"
                                alt=""
                                width="43"
                                height="33"
                            />
                            <img
                                loading="lazy"
                                decoding="async"
                                className={s.cardIcon}
                                src="https://dev.mightyaussie.com/wp-content/uploads/2019/04/card-amex.png"
                                alt=""
                                width="43"
                                height="33"
                            />
                        </p>
                        <p>
                            <strong>■事前クレジットカード決済の場合</strong><br />
                            VISA,MASTER,AMEXカード<br />
                            <img
                                loading="lazy"
                                decoding="async"
                                className={s.cardIcon}
                                src="https://dev.mightyaussie.com/wp-content/uploads/2019/04/card-visa.png"
                                alt=""
                                width="43"
                                height="33"
                            />
                            <img
                                loading="lazy"
                                decoding="async"
                                className={s.cardIcon}
                                src="https://dev.mightyaussie.com/wp-content/uploads/2019/04/card-master.png"
                                alt=""
                                width="43"
                                height="33"
                            />
                            <img
                                loading="lazy"
                                decoding="async"
                                className={s.cardIcon}
                                src="https://dev.mightyaussie.com/wp-content/uploads/2019/04/card-amex.png"
                                alt=""
                                width="43"
                                height="33"
                            />
                            <br />
                            <span style={{ fontSize: '10pt', color: '#e00b0b' }}>
            <strong>※JCBのみ利用できませんのでご注意ください</strong>
        </span>
                        </p>
                    </div>
                    <div className={s.wrapper}>
                        <div className={`${s.singleImage} ${s.alignLeft} ${s.custom}`}>
                            <figure className={s.figure}>
                                <div className={`${s.imageWrapper} ${s.boxBorderGrey}`}>
                                    <img
                                        loading="lazy"
                                        decoding="async"
                                        width="750"
                                        height="300"
                                        src="https://dev.mightyaussie.com/wp-content/uploads/2019/04/deal_tit12.png"
                                        className={s.image}
                                        alt="すごい理由4.ジェイさんツアーはお客様に喜んでもらうためのサービスがスゴイ！"
                                        title="deal_tit12"
                                        srcSet="https://dev.mightyaussie.com/wp-content/uploads/2019/04/deal_tit12.png 750w, https://dev.mightyaussie.com/wp-content/uploads/2019/04/deal_tit12-300x120.png 300w, https://dev.mightyaussie.com/wp-content/uploads/2019/04/deal_tit12-600x240.png 600w"
                                        sizes="(max-width: 750px) 100vw, 750px"
                                    />
                                </div>
                            </figure>
                        </div>

                        <div className={`${s.singleImage} ${s.alignLeft}`}>
                            <figure className={s.figure}>
                                <div className={`${s.imageWrapper} ${s.boxBorderGrey}`}>
                                    <img
                                        loading="lazy"
                                        decoding="async"
                                        width="681"
                                        height="105"
                                        src="https://dev.mightyaussie.com/wp-content/uploads/2019/04/deal_tit13.png"
                                        className={s.image}
                                        alt="理由1.うれしいサービス！雨が降っても大丈夫！"
                                        title="deal_tit13"
                                        srcSet="https://dev.mightyaussie.com/wp-content/uploads/2019/04/deal_tit13.png 681w, https://dev.mightyaussie.com/wp-content/uploads/2019/04/deal_tit13-300x46.png 300w, https://dev.mightyaussie.com/wp-content/uploads/2019/04/deal_tit13-600x93.png 600w"
                                        sizes="(max-width: 681px) 100vw, 681px"
                                    />
                                </div>
                            </figure>
                        </div>

                        <div className={s.textColumn}>
                            <div className={s.wrapper}>
                                <table className={s.tableNone} style={{ width: '100%' }}>
                                    <tbody>
                                    <tr>
                                        <td style={{ width: '80px' }}>
                                            <img
                                                loading="lazy"
                                                decoding="async"
                                                className={s.icon}
                                                src="https://dev.mightyaussie.com/wp-content/uploads/2019/04/deal_ico6.png"
                                                alt=""
                                                width="80"
                                                height="80"
                                            />
                                        </td>
                                        <td>
                            <span style={{ color: '#993300', fontSize: '20pt' }}>
                                <strong>突然の悪天候でも<br />楽しめるツアーをご提案！</strong>
                            </span>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div className={`${s.infoBox} ${s.standard} ${s.rounded} ${s.colorInfo}`}>
                            <div className={s.icon}>
                                <i className="fas fa-info-circle" />
                            </div>
                            <p>
                                予約当日、まさかの悪天候、オプショナルツアーに行けない・・・でもご安心を！<br />
                                ジェイさんツアーでは雨や悪天候でも代わりのオプショナルツアーをご用意できます。<br />
                                お気軽にご相談ください。
                            </p>
                        </div>

                        <div className={s.emptySpace} style={{ height: '1.5em' }}>
                            <span className={s.emptySpaceInner}></span>
                        </div>

                        <div className={`${s.singleImage} ${s.alignLeft}`}>
                            <figure className={s.figure}>
                                <div className={`${s.imageWrapper} ${s.boxBorderGrey}`}>
                                    <img
                                        loading="lazy"
                                        decoding="async"
                                        width="656"
                                        height="192"
                                        src="https://dev.mightyaussie.com/wp-content/uploads/2019/04/deal_tit14.png"
                                        className={s.image}
                                        alt="理由2.うれしいサービス！48時間前までキャンセル無料"
                                        title="deal_tit14"
                                        srcSet="https://dev.mightyaussie.com/wp-content/uploads/2019/04/deal_tit14.png 656w, https://dev.mightyaussie.com/wp-content/uploads/2019/04/deal_tit14-300x88.png 300w, https://dev.mightyaussie.com/wp-content/uploads/2019/04/deal_tit14-600x176.png 600w"
                                        sizes="(max-width: 656px) 100vw, 656px"
                                    />
                                </div>
                            </figure>
                        </div>

                        <div className={s.textColumn}>
                            <div className={s.wrapper}>
                                <p>
                <span style={{ color: '#993300', fontSize: '20pt' }}>
                    <strong>お客様都合による参加日の変更も<br />24時間前まで無料で対応可能！</strong>
                </span>
                                </p>
                            </div>
                        </div>

                        <div className={`${s.infoBox} ${s.standard} ${s.rounded} ${s.colorInfo}`}>
                            <div className={s.icon}>
                                <i className="fas fa-info-circle" />
                            </div>
                            <p>
                                <strong className={s.under}>ジェイさんオリジナルツアーに限り</strong>、3日前からキャンセル料が必要なツアーが多い中、
                                ジェイさんツアーでは参加日の変更やキャンセルも、ツアー開始の24時間前までならキャンセル料は必要ありません。<br />
                                <span className={s.note}>※詳しくは<a href="/term">予約規定</a>をご覧ください。</span>
                            </p>
                        </div>

                        <div className={s.emptySpace} style={{ height: '1.5em' }}>
                            <span className={s.emptySpaceInner}></span>
                        </div>

                        <div className={`${s.singleImage} ${s.alignLeft}`}>
                            <figure className={s.figure}>
                                <div className={`${s.imageWrapper} ${s.boxBorderGrey}`}>
                                    <img
                                        loading="lazy"
                                        decoding="async"
                                        width="671"
                                        height="177"
                                        src="https://dev.mightyaussie.com/wp-content/uploads/2019/04/deal_tit15.png"
                                        className={s.image}
                                        alt="理由3.うれしいサービス！安心価格でオーダーメイドツアー"
                                        title="deal_tit15"
                                        srcSet="https://dev.mightyaussie.com/wp-content/uploads/2019/04/deal_tit15.png 671w, https://dev.mightyaussie.com/wp-content/uploads/2019/04/deal_tit15-300x79.png 300w, https://dev.mightyaussie.com/wp-content/uploads/2019/04/deal_tit15-600x158.png 600w"
                                        sizes="(max-width: 671px) 100vw, 671px"
                                    />
                                </div>
                            </figure>
                        </div>

                        <div className={s.textColumn}>
                            <div className={s.wrapper}>
                                <table className={s.tableNone} style={{ width: '100%' }}>
                                    <tbody>
                                    <tr>
                                        <td style={{ width: '80px' }}>
                                            <img
                                                loading="lazy"
                                                decoding="async"
                                                className={s.icon}
                                                src="https://dev.mightyaussie.com/wp-content/uploads/2019/04/deal_ico7.png"
                                                alt=""
                                                width="80"
                                                height="80"
                                            />
                                        </td>
                                        <td>
                                            <strong style={{ color: '#993300', fontSize: '20pt' }}>
                                                ケアンズ周辺を<br />あなたの希望プランで満喫！<br />
                                            </strong>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div className={`${s.infoBox} ${s.standard} ${s.rounded} ${s.colorInfo}`}>
                            <div className={s.icon}>
                                <i className="fas fa-info-circle" />
                            </div>
                            <p>
                                <strong className={s.under}>ケアンズで創業20年以上のジェイさんツアー</strong>だから、通常できない体験もオーダーメイドツアーで実現可能なんです！<br />
                                独自のネットワークを生かし、あなたのアイデアやトライしたいことを叶えます！
                            </p>
                            <p>
                                LINEでお気軽に相談ができますので、ぜひご活用くださいませ★
                            </p>
                        </div>
                    </div>
                    <div className={s.wrapper}>
                        <div className={`${s.textColumn} ${s.contentElement}`}>
                            <div className={s.wrapper}>
                                <p style={{ textAlign: 'center' }}>
                <span style={{ color: '#993300' }}>
                    <strong>
                        <span style={{ fontSize: '20pt' }}>
                            ジェイさんツアーは<br />
                            ケアンズツアーを提供しているどこよりも<br />
                            満足度が高いと自負しております！
                        </span>
                    </strong>
                </span>
                                    <br />
                                    <span style={{ color: '#993300' }}>
                    <span style={{ fontSize: '26.6667px' }}>
                        <b>お気軽にLINEでご相談くださいね★</b>
                    </span>
                </span>
                                </p>
                            </div>
                        </div>

                        <div className={`${s.singleImage} ${s.alignCenter}`}>

                        </div>

                        <div className={s.buttonContainer}>
                            <a
                                className={s.button}
                                href="https://line.me/R/ti/p/%40dii1064j"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <i className="fa fa-arrow-circle-right" /> LINEで聞いてみる
                            </a>
                        </div>
                    </div>



                </section>
            </div>

        </div>


    </>
  );
};

export default About;
